import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import StoreList from './store-list';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor';
import { getOutlets } from '../../actions/outlet';
import { loadPageContent } from '../../actions/content';
import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

import './store-summary.css';

class StoreSummary extends Component {
  handleContentSaved = () => {
    const { dispatch } = this.props;

    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'store-summary';
    this.stores = [];
  }

  UNSAFE_componentWillMount() {
    const { dispatch, registration } = this.props;

    if (registration.pending && registration.internal) {
      dispatch({type: 'FINISH_REGISTRATION'});
      dispatch(getOutlets(false));
    } else {
      dispatch(getOutlets(registration.pending));
    }

    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    const {
      registration, contents, stores, fetching, fetched
    } = this.props;
    const { pageSlug } = this;

    return (
      <Container fluid className={`stores ${registration.pending ? 'user-inner-container' : ''}`}>
        <Row>
          <Col lg={12} className={`stores-title-${registration.pending ? 'left' : 'center'}`}>
            {registration.pending && (
              <img src={IgniteUkLogo} alt="Ignite UK" />
            )}
            <PageTitle>
              Store summary
            </PageTitle>
          </Col>
        </Row>
        {
          !registration.pending && (
            <Row className="editable-content-wrapper">
              <Col lg={12}>
                <InlineCKEditor
                  contents={contents[`${pageSlug}_content_text`]}
                  identifier={`${pageSlug}_content_text`}
                  onContentSaved={this.handleContentSaved}
                />
              </Col>
            </Row>
          )}
        <Row>
          <Col lg={12}>
            <StoreList
              fetched={fetched}
              fetching={fetching}
              registration={registration}
              stores={stores}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  stores: state.stores.stores,
  fetched: state.stores.fetched,
  fetching: state.stores.fetching,
  registration: state.registration,
  storeRewards: state.deep.store_summary,
  contents: state.content.list
});

export default connect(mapStateToProps)(StoreSummary);
